import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { Button, Link } from '@hotjar/hotsauce';
import { useHelpHotjarUrl } from '@hotjar/translations';
import { Action, Container, Content, Image, ErrorTitle as Title, Subtitle } from './common';
import UpgradeIncreaseCoverageImage from '../../icons/upgrade-increase-coverage.svg';

const StyledContent = styled(Content)`
  max-width: 320px;
`;

export const NoDataIncreaseCoverageError = ({
  onUpgrade,
}: {
  onUpgrade: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <Container>
      <StyledContent>
        <Image alt="Title" src={UpgradeIncreaseCoverageImage} />
        <Title as="p" textType="subtitle1">
          {t('heatmaps:error-states.increase-coverage.title')}
        </Title>
        <Subtitle as="p" textType="caption" textColor="text_light">
          {t('heatmaps:error-states.increase-coverage.subtitle')}
        </Subtitle>
        <Action hasExtraPadding>
          <Link
            kind="standalone"
            isExternal
            href={`${helpHotjarUrl}/articles/1500011350202-How-Does-Sampling-Work`}
          >
            {t('heatmaps:error-states.increase-coverage.action-how-sampling-work')}
          </Link>
        </Action>
        <Action hasExtraPadding>
          <Button icon="crown" kind="secondary" onClick={onUpgrade}>
            {t('heatmaps:error-states.increase-coverage.action-upgrade')}
          </Button>
        </Action>
      </StyledContent>
    </Container>
  );
};
